import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SButtonsWrapper = styled.div`
  display: flex;
  gap: 1.25rem;
  margin-top: 1.5rem;
  margin-bottom: var(--p-button);

  @media ${BREAKPOINTS.SM.max} {
    flex-direction: column;
  }

  @media ${BREAKPOINTS.MD.max} {
    & > button {
      flex: 1;
    }
  }
`
